import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcCellularGateway = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M4 10.5A1.5 1.5 0 0 1 5.5 9h13a1.5 1.5 0 0 1 1.5 1.5v10a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 20.5v-10Z",
  fill: "var(--mds-nav-icon-accent)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M8 1a1 1 0 0 0-1 1v6h2V2a1 1 0 0 0-1-1Zm8 0a1 1 0 0 0-1 1v6h2V2a1 1 0 0 0-1-1Z",
  fill: "var(--mds-nav-icon-weak)"
})), "IcCellularGateway");

export { IcCellularGateway };
//# sourceMappingURL=ic-cellular-gateway.js.map
